<app-dropdown
	dropDownId="country-selector"
	[displayAsInput]="true"
	[dropdownWidth]="dropdownWidth"
	[selectedKey]="selectedKey"
	[content]="countriesArray"
	[search]="true"
	(keyOut)="setCountryFormValue($event)">
</app-dropdown>
